import { validation } from './validation.js';
import { info, success, error } from './notification.js';
import { TYPES } from './types.js';

const returnsForm = () => {
  const form = document.querySelector('.returns__form');
  if (!form) return;
  const inputs = form.querySelectorAll('input');
  const submitButton = form.querySelector('.returns__submit');

  inputs.forEach((input) => {
    input.addEventListener('input', () => {
      const allInputsFilled = Array.from(inputs).every((input) => input.value.trim() !== '');

      if (allInputsFilled) {
        submitButton.classList.remove('button--disabled');
      } else {
        submitButton.classList.add('button--disabled');
      }
    });
  });
};

const submitReturn = (event) => {
  if (event) event.preventDefault();

  const form = document.querySelector('.returns__form');
  if (!form) return;
  const inputs = form.querySelectorAll('input');

  const emailInput = form.querySelector('input[type="email"]');

  if (!validation.email(emailInput.value)) {
    error(TYPES.RETURNS.EMAIL_INVALID);
    return;
  }

  inputs.value = '';
  success(TYPES.RETURNS.SUCCESS);
};

export const returns = () => {
  returnsForm();
  window.Solver.submitReturn = submitReturn;
};
